  document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.custom-splide.splide').forEach(el => {
    const progressBar = el.querySelector('.custom-splide__progress-bar');

    const sp = new Splide(el, {
      perPage: 4,
      perMove: 1,
      gap: '5px',
      pagination: false,
      arrows: true,
      breakpoints: {
        990: { perPage: 3 },
        768: {
          perPage: 2,
          arrows: false
        },
        480: { perPage: 2 },
      },
    });

    sp.on('mounted move', () => {
      const end = sp.Components.Controller.getEnd() + 1;
      const index = sp.index + 1;
      const progress = Math.min((index / end) * 100, 100);
      if (progressBar) {
        progressBar.style.width = `${progress}%`;
      }
    });

    sp.mount();
  });
});